// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2IXty","inner":"Footer_inner__3Hfgh","nextIcon":"Footer_nextIcon__3UKZ0","innerLeft":"Footer_innerLeft__JIJy3"};